<template>
  <div class="page__components_tab">
    <div class="page__components_div">
      <div class="body__components_content_div">
        <!-- 左侧tabs -->
        <div class="body__sidebar_div">
          <div class="component-details">
            <div style="width: 80%">
              <div class="component-details-title">
                {{ project.projectTitle }}
              </div>
              <div class="component-details-name">
                {{ project.projectName }}
              </div>
            </div>
            <a-dropdown>
              <a-icon class="project-edit-button" @click="e => e.preventDefault()" type="more" />
              <a-menu slot="overlay">
                <a-menu-item @click="showProjectMessage">
                  编辑项目
                </a-menu-item>
                <a-menu-item @click="exportProject">
                  导出项目
                </a-menu-item>
              </a-menu>
            </a-dropdown>
            <!-- <img
              class="project-edit-button"
              :src="editClickedImg"
              @click="showProjectMessage"
            />
            <a-icon class="project-edit-button" type="export" /> -->
          </div>
          <div
            v-for="(item, index) in leftTabsList"
            :key="index"
            class="body__sidebar_components_box"
            @click="switchClick(item.id)"
            :class="leftCurrent == item.id ? 'firstBg' : ''"
          >
            <img
              :class="
                item.id == 3
                  ? 'body__sidebar_member_icon'
                  : 'body__sidebar_components_icon'
              "
              :src="item.img"
              alt=""
            />
            <span class="body__sidebar_components_text" :lines="undefined">
              {{ item.name }}
            </span>
          </div>
        </div>

        <!-- 右侧组件搜索框及组件详情 -->
        <div class="body__main_div" id="search-body" v-show="leftCurrent != 3">
          <div class="search-head">
            <a-input-search
              class="search-head-input"
              placeholder="请输入关键词和组件名称"
              @search="onSearch"
              v-model="list_params.name"
              enterButton="搜索"
              size="large"
            />
          </div>
          <div class="search-choose-block">
            <div class="search-choose-content">
              <TagList :tags="tags" @tagFilter="tagFilter" />
              <a-divider dashed />
              <Sort
                @addProject="uploadClick"
                @editProjects="editProjects"
                :addOrCancel="upload"
                :editOrDelet="editOrDelet"
                :editProjectVisible="editProjectVisible"
                :curType="curType"
                :sortRule="sortRule"
                @changeCurType="changeCurType"
                :addPageText="addPageText"
                @addPage="addPage"
              />
            </div>
          </div>
          <!-- 第一个 -->
          <div class="body__grid_first_div">
            <div
              class="body__table_box"
              v-for="(item, index) in arrayList"
              :key="index"
              @click="cardsClick(item)"
            >
              <div class="edittool" @mouseleave="leave(item)" v-if="item.seen">
                <!-- <div class="edittool-detalis">symbolID:{{ item.symbolId }}</div> -->
              </div>
              <div
                class="edittool"
                @mouseleave="leave(item)"
                v-if="item.seensketch"
              >
                <div class="edittool-detalis">
                  将组件名称复制到sketch/xmind中导入:
                  {{ item.componentRoute }}
                </div>
              </div>
              <div class="edittool" v-if="editProjectVisible">
                <div class="radio-position" @click="selectRadio(item)">
                  <img
                    v-if="!item.showSelect"
                    style="width: 20px; height: 20px"
                    src="../../../assets/select.png"
                    alt=""
                  />
                  <img
                    v-if="item.showSelect"
                    style="width: 20px; height: 20px"
                    src="../../../assets/select-on.png"
                    alt=""
                  />
                </div>
                <div class="edit-status">
                  <div
                    @click.stop="editComponent(item)"
                    class="edit-button edit-other"
                  >
                    编辑
                  </div>
                  <div class="edit-button" @click.stop="deleteComponent(item)">
                    删除
                  </div>
                </div>
              </div>
              <div class="body__oneform_box">
                <div class="card-title">
                  <div class="body__oneform_info" :lines="undefined">
                    {{ item.title }}
                  </div>
                  <div class="body__oneform_info">
                    {{ item.name }}
                  </div>
                </div>

                <a-icon
                  @click.stop="copy(item)"
                  style="font-size: 20px; color: #999999"
                  class="body__oneform_icon"
                  type="copy"
                />
              </div>
              <div class="body__introduce_div">
                <div
                  @mouseenter="enter(item)"
                  style="
                    border-radius: 5px;
                    box-sizing: 0 0 20px rgba(0, 0, 0, 0.05);
                  "
                >
                  <img
                    class="body__introduce_img"
                    :src="item.smallImg"
                    alt=""
                  />
                </div>
              </div>
              <div class="body__author_div">
                <div class="body__author_box">
                  <span class="body__author_text" :lines="undefined">
                    作者:{{ item.createBy }}
                  </span>
                  <span class="body__author_uploadtime_text" :lines="undefined"
                    >上传时间: &nbsp;{{ item.createTime }}</span
                  >
                </div>
                <div class="body-tags" v-if="!item.tagNames">
                  <span >暂无标签</span>
                </div>
                <div class="body-tags" v-if="item.tagNames">
                  <span v-for="(str, index) in item.tagNames" :key="index">
                    {{str}}
                  </span>
                </div>
                <div class="body__style_div">
                  <div class="body__style_box" @click.stop="praiseAdd(item)">
                    <img
                      class="body__give_like_image"
                      :src="
                        require(item.likeStatus == 0
                          ? '@/assets/component/list/imgpraise.png'
                          : '@/assets/component/list/praise.png')
                      "
                      alt=""
                    />
                    <span
                      class="body__give_like_txt"
                      :lines="undefined"
                      :class="{ Active: item.likeStatus != 0 ? true : false }"
                    >
                      {{ item.likeNum || item.likeStatus }}
                    </span>
                  </div>
                  <div>
                    <a-icon style="color: #999999" type="eye" />
                    <span
                      style="margin-left: 5px"
                      class="body__give_like_txt"
                      >{{ seeNum }}</span
                    >
                  </div>
                  <div class="body__download_div" @click.stop="downloadAdd">
                    <img
                      class="body__download_icon"
                      :src="
                        require(msg.downloadflag
                          ? '@/assets/component/list/img_32360_0_1.png'
                          : '@/assets/component/list/download.png')
                      "
                      alt=""
                    />
                    <span
                      class="body__download_num"
                      :lines="undefined"
                      :class="{ Active: !msg.downloadflag }"
                    >
                      {{ msg.downloadNum }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="pagination">
            <a-pagination
              :current="list_params.pageNo"
              @change="pageChange"
              size="large"
              :total="list_total"
              :pageSize="list_params.pageSize"
              show-quick-jumper
            />
          </div>
        </div>

        <!-- 右侧成员信息 -->
        <div class="body__main_div" v-show="leftCurrent == 3">
          <Member v-show="leftCurrent == 3" :depId="sysDepartId" />
        </div>
      </div>
    </div>

    <!-- 修改组件弹窗 -->
    <!-- <a-modal v-model="visible" title="修改组件" @ok="handleOk">
      <div>
        <div class="edit-input">
          <span>标题:</span>
          <div class="edit-input-class"><a-input v-model="titleValue" /></div>
        </div>
        <div class="edit-input">
          <span>名字:</span>
          <div class="edit-input-class"><a-input v-model="nameValue" /></div>
        </div>
        <div class="edit-input">
          <span>标签:</span>
          <div class="edit-input-class"></div>
        </div>
      </div>
    </a-modal> -->

    <a-modal
      v-model="visible"
      width="600px"
      :title="modalTitle"
      :destroyOnClose="true"
    >
      <EditPage :editData="editData" :type="list_params.type" @nameStatusChange="nameStatusChange"/>
      <div slot="footer" class="editPage__footer--btn">
        <a-button class="footer__btn" @click="cancelChange">取 消</a-button>
        <a-button class="footer__btn" type="primary" @click="handleOk"
          >保 存</a-button
        >
      </div>
    </a-modal>

    <!-- 修改项目弹窗 -->
    <edit-project-modal
      :editProjectMessageVisible="editProjectMessageVisible"
      :editProjectMessageType="editProjectMessageType"
      :project="project"
      :api="api"
      :url="url"
      @handleOk="editProjectMessage"
      @editMessageType="editMessageType"
      @handleCancel="handleCancel"
    />
  </div>
</template>
<script>
import _ from 'lodash';
import Sort from "@/views/project/list/sort/Sort.vue";
import projectApi from "@/request/api-manager/project.js";
import componentApi from "@/request/api-manager/component.js";
import global_ from "@/utils/global.js";
import TagList from "@/components/TagList/TagList.vue";
import viewProjectTag from "@/request/api-manager/viewProjectTag.js";
import EditProjectModal from "@/views/component/list/EditProjectModal/EditProjectModal.vue";
import EditPage from "@/views/pageComponent/EditPage";
import { USER_ID } from "@/store/mutation-types";
import Member from "@/views/component/list/member/index.vue";
import projectUserApi from "@/request/api-manager/projectUser.js";
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export default {
  data() {
    return {
      nameStatus: true,
      modalTitle: "编辑",
      titleValue: "",
      nameValue: "",
      editId: "",
      visible: false,
      message: "Copy These Text",
      symbolID: "",
      selectComponentIds: [],
      seeNum: 0,
      showSelect: true,
      showUpload: true,
      showDelete: false,
      editProjectVisible: false,
      seen: false,
      msg: {
        praiseNum: 0,
        downloadNum: 0,
        praiseflag: true,
        downloadflag: true,
      },
      arrayList: [],
      editClickedImg: require("@/assets/component/list/edit.png"),
      tags: [],
      curType: "createTime",
      sortRule: "asc",
      leftCurrent: 1,
      list_params: {
        projectId: "",
        pageSize: 8,
        pageNo: 1,
        type: 0,
        name: "",
      },
      list_total: 100,
      project: {},
      tagListId: [],
      upload: "上传",
      editOrDelet: "编辑",
      editProjectMessageVisible: false,
      editProjectMessageType: "basic",
      addPageText: '添加',
      api: "",
      url: "",
      leftTabsList: [
        {
          id: 1,
          img: require("@/assets/component/list/img_32360_0_59.png"),
          name: "组件",
        },
        {
          id: 2,
          img: require("@/assets/component/list/img_32360_0_66.png"),
          name: "页面",
        },
        {
          id: 3,
          img: require("@/assets/component/list/member.png"),
          name: "成员",
        },
      ],
      editData: {}, // 编辑的数据
      tempEditData: {},
      sysDepartId: ''
    };
  },
  components: {
    TagList,
    Sort,
    EditProjectModal,
    EditPage,
    Member,
  },
  watch:{
  },
  mounted() {
    let self = this;
    self.getProject();
    if (self.$route.query.leftCurrent) {
      self.leftCurrent = self.$route.query.leftCurrent;
      this.list_params.type = 1;
    }
    self.queryComponentTagList();
    // self.getProjectMember();
  },
  methods: {
    exportProject(){
      let self = this;
      let url = "/api/design/project/exportProject";
      let params = { projectId: self.project.id };
      self.$downloadFile(self.project.projectName + ".zip", url, params);
    },
    nameStatusChange(val) {
      this.nameStatus = val
    },
    cancelChange() {
      this.visible = false
      this.editData = this.tempEditData
    },
    changeIndentity(record) {
      console.log(record);
    },
    handleChange(value) {
      console.log(value);
    },
    onChange(date, dateString) {
      console.log(date, dateString);
    },
    showProjectMessage() {
      this.editProjectMessageVisible = true;
    },
    editProjectMessage(project, api, url) {
      let self = this;
      if (self.editProjectMessageVisible) {
        let oldParams = JSON.parse(project.projectParams);
        console.log(oldParams, "parse后的值");
        let message = JSON.stringify({
          ...oldParams,
          url: url,
          api: api,
        });
        console.log(message, "stringify后的message值");
        let params = {
          id: project.id,
          name: project.projectName,
          title: project.projectTitle,
          description: project.projectDescription,
          params: message,
        };
        console.log("查看json", params, url, api);
        projectApi.edit(params).then((res) => {
          if (res.success) {
            this.$message.success("修改成功");
          } else {
            this.$message.warning(res.message);
          }
        });
      }
      self.editProjectMessageVisible = false;
    },
    handleCancel() {
      let self = this;
      self.getProject();
      self.queryComponentTagList();
      self.editProjectMessageVisible = false;
    },
    getProject() {
      let self = this;
      let id = self.$route.query.projectId;
      viewProjectTag.queryById({ id }).then((res) => {
        //错误处理
        if(!res.success){
          self.list_params.projectId = "-1"
          self.$message.warning(res.message);
        }
        if (
          res.result.projectParams == null ||
          res.result.projectParams == undefined
        ) {
          res.result.projectParams = "{}";
        }
        let projectParams = JSON.parse(res.result.projectParams);
        console.log("参数", JSON.parse(res.result.projectParams));
        self.url = projectParams.url == null ? "" : projectParams.url;
        self.api = projectParams.api == null ? "" : projectParams.api;
        self.project = res.result;
        console.log("self.project",self.project);
        self.list_params.projectId = self.project.id;
        self.list(self.list_params);
        self.sysDepartId = res.result.sysDepartId
        console.log("project455647654654764", self.project);
      });
    },

    //编辑组件详情
    editComponent(item) {
      // console.log('this.titleValue',this.titleValue,this.nameValue)
      if (this.leftCurrent == 1) {
        this.modalTitle = '组件详情修改'
      } else if (this.leftCurrent == 2) {
        this.modalTitle = '页面详情修改'
      }
      this.titleValue = item.title;
      this.nameValue = item.name;
      this.editId = item.id;
      this.visible = true;
      this.editData = JSON.parse(JSON.stringify(item));
      this.tempEditData = JSON.parse(JSON.stringify(item))
      console.log("编辑组件详情", this.editData);
    },

    deleteComponent(item) {
      let self = this;
      self.$confirm({
        title: "确认删除",
        content: "是否删除选中组件?",
        onOk: function () {
          componentApi.delete({ id: item.id }).then((res) => {
            if (res.success) {
              self.editClick();
              self.list(self.list_params);
              self.$message.success(res.message);
            } else {
              self.$message.warning(res.message);
            }
          });
        },
      });
    },

    handleOk() {
      if (!this.nameStatus) {
        return
      }
      console.log(this.editData,'this.editData');
      Object.assign(this.editData, {
        createBy: undefined,
        createTime: undefined,
        updateBy: undefined,
        updateTime: undefined
      })
      this.visible = false;
      componentApi.editComponent(this.editData).then((res) => {
        console.log(res,'resresres');
        this.apiResult(res);
      });
    },

    //查询所有的组件标签
    queryComponentTagList() {
      let self = this;
      projectApi
        .tagList({
          pageSize: 10,
          pageNo: 1,
          type: 1,
          projectIds: self.list_params.projectId,
        })
        .then((res) => {
          console.log("tag查询", res.result.records);
          res.result.records.forEach((element) => {
            element.disabled = true;
          });
          // _.take获取数组前n个元素
          self.tags = res.result.records;
          // let listTag = _.take(res.result.records, 6);
          // console.log("listTag",listTag)
          // let tmpTag = []
          // listTag.forEach((item)=>{
          //   console.log(item.name)
          //   // console.log(this)
          //   tmpTag.push(item.name)
          // })
          // self.tags = tmpTag
          // this.$forceUpdate()
          // console.log("self.tags", self.tags);
        });
    },
    dataProcessing(val) {
      console.log("复制信息", val);
      let project = this.project;
      this.message = `/${project.userName}/${project.name}/${val.name}`;
      //  /{{ project.userName }}/{{ project.name }}/{{ item.name }}
    },
    copy: function (val) {
      if (this.editOrDelet == "编辑") {
        val.seensketch = true;
        // this.dataProcessing(val);
        this.$copyText(val.componentRoute).then(
          function (e) {
            val.seensketch = true;
          },
          function (e) {
            alert("Can not copy");
            console.log(e);
          }
        );
      } else {
        val.seensketch = false;
      }
    },

    selectRadio(item) {
      if (!item.showSelect) {
        this.selectComponentIds.push(item.id);
      } else {
        this.selectComponentIds = this.selectComponentIds.filter((id) => {
          return id != item.id;
        });
      }
      item.showSelect = !item.showSelect;
      console.log("this.selectComponentIds", this.selectComponentIds);
    },
    editClick() {
      console.log("editClickb编辑");
      if (this.editOrDelet == "编辑") {
        this.editOrDelet = "取消";
        this.showUpload = false;
        this.showDelete = true;
      } else {
        this.editOrDelet = "编辑";
        this.selectComponentIds = [];
        _.each(this.arrayList, (item) => {
          item.showSelect = false;
        });
        this.showUpload = true;
        this.showDelete = false;
      }

      this.editProjectVisible = !this.editProjectVisible;
    },
    //鼠标移入
    enter(item) {
      if (this.editOrDelet == "编辑") {
        item.seen = true;
      } else {
        item.seen = false;
      }
    },
    //鼠标移出
    leave(item) {
      item.seen = false;
      item.seensketch = false;
    },
    // 点赞加1
    praiseAdd(item) {
      console.log(item, "点赞--------", item.likeStatus);
      if (item.likeStatus == 0) {
        Object.assign(item, {
          likeStatus: 1,
        });
      } else {
        Object.assign(item, {
          likeStatus: 0,
        });
      }
      console.log(item, "itemmmm");
      this.giveLike(item).then(() => {
        this.list(this.list_params);
      });
    },
    // 下载量加1
    downloadAdd() {
      // this.downloadNum++
      this.msg.downloadNum = this.msg.downloadflag
        ? this.msg.downloadNum + 1
        : this.msg.downloadNum - 1;
      this.msg.downloadflag = !this.msg.downloadflag;
    },
    //展示数据
    list(params) {
      console.log("params", params);
      let self = this;
      let project = self.project;
      let status = self.renameCurType(self.curType);
      componentApi.list(params, status, self.sortRule).then((res) => {
        if (res.result.total == 0) {
          self.$message.info("暂无数据");
        }
        res.result.records.forEach((element) => {
          element.componentRoute = `/${project.userName}/${project.projectName}/${element.name}`;
          element.seen = false;
          element.seensketch = false;
          element.showSelect = false;
          element.praiseNum = 0;
          element.praiseflag = false;
        });
        self.arrayList = res.result.records;
        _.each(self.arrayList, item => {
          item.smallImg = `${item.smallImg}?t=${Math.random()}`
        })
        self.list_total = res.result.total;
        // self.list_params.pageNo = 1
        console.log("查询内容", self.arrayList);
      });
    },

    //(待修改：用title字段搜索查询改成模糊查询）
    onSearch(value) {
      let self = this;
      self.list(self.list_params);
    },
    pageChange(page) {
      let self = this;
      self.list_params.pageNo = page;
      self.list(self.list_params);
    },
    // 上传
    uploadClick() {
      if (this.upload == "取消") {
        this.editProjectVisible = false;
        this.upload = "上传";
        this.editOrDelet = "编辑";
      } else {
        let self = this;
        self.$router.push({ path: "/component/upload" });
      }
    },
    // 组件点击
    switchClick(status) {
      // console.log(status)
      if (status == 2) {
        this.addPageText = "添加";
        this.leftCurrent = 2;
        this.list_params.type = 1;
      } else if (status == 1) {
        this.addPageText = "添加";
        this.leftCurrent = 1;
        this.list_params.type = 0;
      } else {
        this.leftCurrent = 3;
      }
      this.$router.replace({ path: "list", query: { projectId: this.$route.query.projectId,leftCurrent: this.leftCurrent } })
      this.list_params.pageNo = 1;
      this.list_params.name = ""
      this.list(this.list_params);
    },
    cardsClick(card) {
      let self = this;
      console.log(this.leftCurrent,self.editOrDelet,'this.leftCurrent');
      if (this.editOrDelet == "编辑" && this.leftCurrent == 2) {
        
        let { href } = this.$router.resolve({
          path: "/edit-page/",
          query: {
            pageId: card.id,
          },
        });
        window.open(href, "_blank");
      } else if (this.editOrDelet == "编辑" && this.leftCurrent == 1) {
        self.$router.push({
          path: "/component/details",
          query: {
            ...card,
            realName: self.project.realName,
          },
        });
      }
    },

    editProjects() {
      if (this.editOrDelet == "编辑") {
        this.editProjectVisible = true;
        this.upload = "取消";
        this.editOrDelet = "删除";
      } else {
        let self = this;
        self.$confirm({
          title: "确认删除",
          content: "是否删除选中项目?",
          onOk: function () {
            let ids = self.selectComponentIds.join(",");
            console.log("执行删除", ids);
            componentApi
              .deleteBatch({ ids: self.selectComponentIds.join(",") })
              .then((res) => {
                self.apiResult(res);
              });
          },
        });
      }
    },
    apiResult(res) {
      let self = this;
      if (res.success) {
        self.editClick();
        self.list(self.list_params);
        self.$message.success(res.message);
      } else {
        self.$message.warning(res.message);
      }
    },
    changeCurType(curType) {
      let self = this;
      if (self.curType == curType) {
        self.sortRule = self.sortRule == "desc" ? "asc" : "desc";
      } else {
        self.curType = curType;
        self.sortRule = "asc";
      }
      self.list(self.list_params);
      console.log("排序规则", self.sortRule);
    },
    //curType关系映射
    renameCurType(curType) {
      let status = curType;
      status =
        status == "projectLikeNum"
          ? "likeNum"
          : status == "projectName"
          ? "name"
          : "createTime";
      return status;
    },
    tagFilter(tagId) {
      let self = this;
      self.list_params.tagIds = tagId;
      self.list(self.list_params);
    },
    editMessageType(value) {
      let self = this;
      self.editProjectMessageType = value;
    },
    addPage() {
      let self = this;
      self.$router.push({ path: "/add-page", query: { id: self.project.id, type: self.list_params.type } });
    },
    /**
     * @description 点赞处理
     * @param {Object} options - 点赞对象
     */
    giveLike(options) {
      return new Promise(async (resolve, rej) => {
        let { id, likeStatus } = options;
        let res = await this.selectComponentLike(id, this.$ls.get(USER_ID));
        if (res == -1) {
          // 为true时,就说明有关联
          this.addComponentLike({
            sysUserId: this.$ls.get(USER_ID),
            componentId: id,
            delFlag: 0,
            status: likeStatus,
          });
          return resolve();
        } else {
          this.editComponentLike(res, likeStatus);
          return resolve();
        }
      });
    },
    /**
     * @description 查询组件id是否存在于组件点赞表中
     * @param {String} componentId -组件id
     * @param {String} sysUserId - 用户id
     */
    async selectComponentLike(componentId, sysUserId) {
      console.log(componentId, sysUserId, "componentId,sysUserId");
      let result = await componentApi
        .listComponentLike({ componentId, sysUserId })
        .then((res) => {
          console.log(res, "查询组件id是否存在于组件点赞表中:结果");
          if (res.result.total == 0) {
            return -1;
          }
          return res.result.records[0].id;
        });
      return result;
    },
    /**
     * @description 该组件与用户不存在关系，组件点赞表进行添加
     * @param {Object} data - 添加的参数
     */
    async addComponentLike(data) {
      let result = await componentApi.addComponentLike(data);
      console.log("添加的结果", result);
    },
    /**
     * @description 该组件与用户存在对应关系，组件点赞表进行编辑
     * @param {String} id - 组件点赞表id
     * @param {Number} likeStatus - 状态
     */
    async editComponentLike(id, likeStatus) {
      console.log(id, "组件点赞表id");
      let result = await componentApi.editComponentLike({
        id,
        status: likeStatus,
      });
      console.log("修改的结果", result);
    },
    // getProjectMember() {
    //   let self = this;
    //   let id = self.$route.query.projectId;
    //   projectUserApi.list({ projectId: id }).then((res) => {
    //     res.result.records.forEach((resp) => {
    //       resp.roleType = this.correspondingRelation(
    //         resp.roleType,
    //         global_.roleType
    //       );
    //     });
    //     self.memberList = res.result.records;
    //   });
    // },
  },
};
</script>
<style lang="less" scoped>
@import "./index.response.css";
@import "./index.less";
</style>
